export const pt = {
  languages: {
    english: "Inglês",
    spanish: "Espanhol",
    dutch: "Holandês",
    french: "Francês",
    portuguese: "Português",
    italian: "Italiano",
    german: "Alemão",
    polish: "Polonês",
    romanian: "Romeno",
    greek: "Grego",
    //TODO: add new language here
  },
  loginPage: {
    title: "Entrar",
    email: "E-mail",
    placeholder: "Digite seu e-mail",
    buttonText: "Entrar",
    loginMessage:
      "Foi enviado um email para o endereço de email proporcionado. Clique no link do email para autenticar.",
    noEmailMessage:
      "Por favor, use o link no e-mail que foi enviado para você para iniciar este processo",
  },
  formPage: {
    title: "Revisão Periódica",
    submittedMessage: "O formulário foi enviado!",
    alreadySubmittedMessage:
      "O formulário já foi enviado! Se você deseja alterar as informações enviadas anteriormente, entre em contato com seu gerente de relacionamento.",
    waitMessage: "Carregando dados, por favor, aguarde...",
    asteriskMessage1: "Por favor, preencha todos os campos com",
    asteriskMessage2: "pois eles são obrigatórios.",
    savedLocallyMessage: "Todas as alterações serão salvas localmente no seu dispositivo.",
    accessFormAgain: "Você pode acessar o formulário novamente usando o link",
    openPRs: "Revisões Periódicas Abertas",
    addRelation: "Adicionar Relação",
    submit: "Enviar",
    continue: "Continuar",
    addFile: "Adicionar Arquivo",
  },
};
